/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * BETWEEN operator looks for values: left <= value <= right.
 */
export interface TimestampBetween {
    /** Left value to compare against. */
    left: Date;
    /** Right value to compare against. */
    right: Date;
}
